
// import { createSlice } from "@reduxjs/toolkit";
// import { getSolarInverter } from "../reduxApi/solarInverterReduxApi";

// const solarInverterSlice = createSlice({
//     name: 'solarInverter',
//     initialState: {
//         status: 'idel',
//         solarInverter: [],
//     },
//     reducers: {
//         deleteSolarInverterAction: (state, action) => {
//             action.payload.forEach((ROWID) => {
//                 const index = state.solarInverter.findIndex((item) => item.ROWID === ROWID);
//                 if (index !== -1) {
//                     state.solarBrand.splice(index, 1);
//                 }
//             });
//         },
//         updateSolarInverterAction: (state, action) => {
//             // console.log("action", action.payload.ROWID)
//             const index = state.solarInverter.findIndex((item) => item.ROWID === action.payload.ROWID)
//             if (index != -1) {
//                 state.solarInverter.splice(index, 1, action.payload)
    
//             }
//         },
//         addSolarInverterAction: (state, action) => {
//             const temp = action.payload.formData;
//             console.log("temp", temp)
//             temp.ROWID = action.payload.ROWID;
//             console.log("temp111", temp)
//             state.solarBrand.unshift(temp);           
//         }
//     },
//     extraReducers: (builder) => {
//         builder.addCase(getSolarInverter.pending, (state, action) => {
//             state.status = 'pending'
//         })
//             .addCase(getSolarInverter.fulfilled, (state, action) => {
//                 state.status = 'fulfilled'
//                 state.solarInverter = action.payload.data.inverters;
//                 console.log("satree",action.payload)
//                 console.log("testing helo Data", action.payload.data.inverters)
//             })
//     }
// })
// export const { deleteSolarInverterAction, updateSolarInverterAction, addSolarInverterAction } = solarInverterSlice.actions
// export default solarInverterSlice.reducer



import { createSlice } from "@reduxjs/toolkit";
import { getSolarInverter } from "../reduxApi/solarInverterReduxApi";

const solarInverterSlice = createSlice({
    name: 'solarInverter',
    initialState: {
        status: 'idel',
        solarInverter: [],
    },
    reducers: {
        deleteSolarInverterAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.solarInverter.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.solarInverter.splice(index, 1); // Fixed: was solarBrand
                }
            });
        },
        updateSolarInverterAction: (state, action) => {
            const index = state.solarInverter.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index !== -1) {
                state.solarInverter.splice(index, 1, action.payload)
            }
        },
        addSolarInverterAction: (state, action) => {
            const temp = action.payload.formData;
            console.log("temp", temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp111", temp)
            state.solarInverter.unshift(temp); // Fixed: was solarBrand          
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getSolarInverter.pending, (state, action) => {
            state.status = 'pending'
        })
        .addCase(getSolarInverter.fulfilled, (state, action) => {
            state.status = 'fulfilled'
            state.solarInverter = action.payload.data.inverters;
            console.log("satree",action.payload)
            console.log("testing helo Data", action.payload.data.inverters)
        })
    }
})

export const { deleteSolarInverterAction, updateSolarInverterAction, addSolarInverterAction } = solarInverterSlice.actions
export default solarInverterSlice.reducer